// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import moment from 'moment-timezone'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/black-green-light.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSquare, faCog, faCheckSquare, faPlusCircle, faMinusCircle, faArrowLeft, faBars, faEnvelope, faPhone, faMousePointer, faMapMarkerAlt, faSchool, faLightbulb, faChartLine, faUsers, faEllipsisV, faCheckCircle, faTimesCircle, faCaretUp, faCaretDown, faPencilAlt, faRecycle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/css/main.css';
//import './output.css';
import lodash from 'lodash';
import VeeValidate from 'vee-validate';
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import vuescroll from 'vuescroll';
import VueGtm from 'vue-gtm';
import Skeleton from 'vue-loading-skeleton';
import helpers from './helpers/helper.js';
import { sanitizeInput } from './utils/sanitizer';
import AuthService from './services/AuthService';
import axios from 'axios';
import accessibleTooltip from './directives/accessibleTooltip.js';

Vue.prototype.$helpers = helpers;
library.add(faSquare, faCheckSquare, faCog, faPlusCircle, faMinusCircle, faArrowLeft, faBars, faEnvelope, faPhone, faMousePointer, faMapMarkerAlt, faSchool, faLightbulb, faChartLine, faUsers, faEllipsisV, faCheckCircle, faTimesCircle, faCaretUp, faCaretDown, faPencilAlt, faRecycle)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueMaterial)
Vue.use(Skeleton)
Vue.use(VueToast, {
	position: 'bottom-right'
});

Vue.use(vuescroll, {
  ops: {
    // The global config
  },
  name: 'myScroll' // customize component name, default -> vueScroll
});
const requireComponent = require.context(
	// The relative path of the components folder
	'./components',
	// Whether or not to look in subfolders
	false,
	// The regular expression used to match base component filenames
	/Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
	const componentConfig = requireComponent(fileName)
	// Get PascalCase name of component
	const componentName = upperFirst(
		camelCase(
			// Strip the leading `'./` and extension from the filename
			fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
		)
	)

	// Register component globally
	Vue.component(
		componentName,
		// Look for the component options on `.default`, which will
		// exist if the component was exported with `export default`,
		// otherwise fall back to module's root.
		componentConfig.default || componentConfig
	)
})


// ======================
// Safe Date (strict parsing)
// ======================
moment.tz.setDefault('America/New_York');

// Define legacy format ONLY if needed
const LEGACY_FORMAT = 'MM/DD/YYYY HH:mm';

function parseStrict(value) {
  if (!value) return moment.invalid();
  // 1. Try ISO
  let m = moment.parseZone(value, moment.ISO_8601, true);
  if (m.isValid()) return m;
  // 2. Try strict legacy format
  if (LEGACY_FORMAT) {
    m = moment.tz(value, LEGACY_FORMAT, true, 'America/New_York');
    if (m.isValid()) return m;
  }
  return moment.invalid();
}

// ======================
// Vue filters for dates
// ======================
Vue.filter('momentDate', function (value) {
  const m = parseStrict(value);
  if (!m.isValid()) return '';
  return m.format('MM/DD/YYYY HH:mm');
})

Vue.filter('momentDateUTC', function (value) {
  if (value && value !== 'N/A') {
    var tz = moment.tz.guess();
    return moment.utc(value).tz(tz).format('MM/DD/YYYY HH:mm');
  } else {
    return value;
  }
});

Vue.filter('dateFormat', function (value) {
  const m = parseStrict(value);
  if (!m.isValid()) return '';
  return m.format('MM/DD/YYYY');
})

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.directive('accessible-tooltip', accessibleTooltip)

Vue.filter('dateFormat', function (value) {
	if (!value) return ''
	return moment(value).tz("America/New_York").format('MM/DD/YYYY');
})

// Create AuthService instance for improved router guard
const authService = new AuthService()

// Check token when user returns to the tab (efficient!)
document.addEventListener('visibilitychange', () => {
	if (!document.hidden) { // User returned to tab
		const authUser = localStorage.getItem('authUser')
		if (authUser && !authService.isAuthenticated()) {
			console.log('🔄 TAB FOCUS: Token expired, logging out...')
			authService.logout()
			if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
				window.location.href = '/login'
			}
		}
	}
})

// Axios interceptor: Check token on API responses (most important!)
axios.interceptors.response.use(
	response => response,
	error => {
		if (error.response && (error.response.status === 401 || error.response.status === 403)) {
			console.log('🔄 API CALL: Token expired (401/403), logging out...')
			authService.logout()
		}
		return Promise.reject(error)
	}
)

router.beforeEach((to, from, next) => {
	if (to.meta.requiresAuth) {
		// Now we actually check if the token is expired, not just if authUser exists
		if (authService.isAuthenticated()) {
			next()
		} else {
			// Token is expired or doesn't exist, redirect to login
			next({
				name: 'Login'
			})
		}
	} else {
		next()
	}
})

router.afterEach((to, from, next) => {
	Vue.nextTick(() => {
		document.title = to.meta.title
	})
})
Vue.prototype.$lodash = lodash;
Vue.prototype.$moment = moment;
Vue.prototype.$gtm = VueGtm;
Vue.use(VueGtm, {
  	//id: 'GTM-P78WW98', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  	// queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
    // 	gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    // 	gtm_preview: 'env-4',
    // 	gtm_cookies_win: 'x'
  	// },
  	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  	debug: true, // Whether or not display console logs debugs (optional)
  	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  	ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
});
Vue.use(lodash);
// Vue.use(moment);
Vue.use(VeeValidate, {
  events: ''
});
Vue.use(VueLoading);
// Vue.prototype.$gtm.debug(false)
Vue.prototype.$eventHub = new Vue(); // Global event hub for easy component-to-component events

Vue.mixin({
    directives: {
        model: {
            inserted(el, binding, vnode) {
                const componentInstance = vnode.componentInstance;
                if (componentInstance &&
                    componentInstance.$options &&
                    componentInstance.$options.methods &&
                    componentInstance.$options.methods.onInput) {

                    const originalUpdateMethod = componentInstance.$options.methods.onInput;
                    componentInstance.$options.methods.onInput = function(event) {
                        event.target.value = sanitizeInput(event.target.value);
                        originalUpdateMethod.call(this, event);
                    };
                }
            }
        }
    }
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js